import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft, LayoutGrid, ExternalLink } from 'lucide-react';
import { v4 } from 'uuid';
import { useAlertContext } from '../contexts/Alert';
import { USER_URL } from '../api_base.js';
import { buildHeaders } from '../utils/apiHeaders.js';
import { checkMaintenance } from "../utils/checkMaintenance.js";

const AppDetail = () => {
    const [app, setApp] = useState(null);
    const [loading, setLoading] = useState(true);

    const { appId } = useParams();
    const { setAlerts } = useAlertContext();
    const navigate = useNavigate();

    const pushAlert = (text) => setAlerts(prev => ([...prev, { id: v4(), text }]));

    useEffect(() => {
        const fetchApp = async () => {
            try {
                const res = await fetch(USER_URL + "/apps/" + appId, {
                    method: "GET",
                    credentials: "include",
                    headers: buildHeaders(),
                });
                const data = await res.json();

                if (!res.ok || data.failed) {
                    if (data.signout) navigate("/auth");
                    else if (data.state === "maintenance") navigate("/maintenance");
                    else pushAlert(data.message || "Oops! something went wrong while loading this app.");
                    return;
                }

                setApp(data.data);
                checkMaintenance(data , navigate);
            } catch (err) {
                pushAlert("Oops! something went wrong while reaching the server.");
            } finally {
                setLoading(false);
            }
        }
        fetchApp();
    }, [appId]);

    return (
        <div className="page">
            <div className="page_header">
                <button className="back" onClick={() => navigate("/apps")}><ChevronLeft /></button>
                <div className="page_title">
                    <h2>App Details</h2>
                    <p>Everything about this app.</p>
                </div>
            </div>

            <div className="page_body">
                {loading ? (
                    <div className="empty_state"><span className="loading"></span></div>
                ) : !app ? (
                    <div className="empty_state">
                        <LayoutGrid size="40" />
                        <h3>App not found</h3>
                    </div>
                ) : (
                    <div className="app_detail_card">
                        {app.appIcon ? <img src={app.appIcon} alt={app.appName} /> : <div className="nav_card_icon" style={{ width: 72, height: 72 }}><LayoutGrid size="28" /></div>}
                        <h2>{app.appName}</h2>
                        <div className="status_row">
                            <span className={`status_dot ${app.inMaintenance ? "maintenance" : ""}`}></span>
                            {app.inMaintenance ? "Under maintenance" : "Running normally"}
                        </div>
                        {app.appLink ? (
                            <a className="pill_button" href={app.appLink} target="_blank" rel="noreferrer">
                                Open App <ExternalLink size="16" />
                            </a>
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    )
}

export default AppDetail;
